import { useAuth } from "context/userContext";
import { useEffect,useState } from "react";
import { FaBars,FaHome,FaTags,FaUser } from "react-icons/fa";
import { useSelector } from "react-redux";
import { useLocation,useNavigate } from "react-router-dom";

const BottomNav = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [discountActive, setDiscountActive] = useState(false);
  const { logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const {
    user,
    userLoading
  } = useSelector((state) => state.user);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Set discount active state based on current path
  useEffect(() => {
    if (location.pathname === '/discount') {
      setDiscountActive(true);
    } else {
      setDiscountActive(false);
    }
  }, [location.pathname]);

  if (!isMobile) return null; // Render only for mobile view

  const handleNavButton = (route) => {
    setDiscountActive(false); // Reset discount active when navigating
    navigate(route);
  };

  const handleDiscountClick = () => {
    setDiscountActive(true);
    // Mark that we should auto-open when page loads
    sessionStorage.setItem('discount_auto_open', 'true');
    // Navigate to discount page
    navigate('/discount');
  };

  const isActive = (path) => {
    if (path === `/employees/${user?.id}`) {
      return location.pathname === path || location.pathname.startsWith(`/employees/${user?.id}/`);
    }
    return location.pathname === path;
  };

  const navItems = [
    {
      icon: FaHome,
      label: 'Home',
      path: '/employee-dashboard',
      active: isActive('/employee-dashboard'),
      onClick: () => handleNavButton('/employee-dashboard')
    },
    {
      icon: FaUser,
      label: 'Profile',
      path: `/employees/${user?.id}`,
      active: isActive(`/employees/${user?.id}`),
      onClick: () => handleNavButton(`/employees/${user?.id}?profile=true`)
    },
    ...(user?.role?.access_scope !== "store_manager" ? [{
      icon: FaTags,
      label: 'Discount',
      path: '/discount',
      active: discountActive || location.pathname === '/discount',
      onClick: handleDiscountClick
    }] : []),
    {
      icon: FaBars,
      label: 'Menu',
      path: '/menu',
      active: location.pathname === '/menu',
      onClick: () => handleNavButton('/menu')
    }
  ];

  return (
    <>
      {/* Bottom Navigation Bar */}
      <div className="bottom-nav">
        {navItems.map((item, index) => {
          const IconComponent = item.icon;
          return (
            <button
              key={index}
              className={`nav-item ${item.active ? 'active' : ''}`}
              onClick={item.onClick}
              aria-label={item.label}
            >
              <IconComponent size={18} />
              <span>{item.label}</span>
            </button>
          );
        })}
      </div>
    </>
  );
};

export default BottomNav;
